/*    
<summary>
  This functional component "AddUser" defines the props like initial values and functions for the child form component.
  Developer:Aashish Singh, Created Date:29-August-2023
</summary>
<returns>Returns JSX</returns>
*/

import "./add-edit-special-scheduler.css";
import { observer } from "mobx-react";
import React, { useEffect } from "react";
import { useStore } from "../../../../contexts/store-provider";
import { formatMessage } from "../../../../translations/format-message";
import toast from "react-hot-toast";
import IAddPriceScheduler, { IAddSpecialScheduler, IUpdatePriceScheduler, IUpdateSpecialScheduler } from "../../../../models/forms/IAddUpdateWeekdayScheduler";
import AddUpdateWeekdaySchedulerForm from "../../forms/add-edit-weekday-scheduler-form";
import AddUpdateSpecialSchedulerForm from "../../forms/add-edit-special-scheduler-form";
import { getTenantAccessFromLocalStorage } from "../../../../helpers/localstorage-helper";


interface IProps {
  id: number;
  modalClosed: () => void;
}

const AddSpecialScheduler = (props: IProps) => {
  const { preferencesStore, priceSchedulerStore } = useStore();
  const { getTenantAccess, getPriceSchedulerAccess } = preferencesStore;
  const { specialSchedulerDetails, GetSpecialSchedulerServiceById, addUpdateSpecialSchedulerState, GetAllSpecialSchedulerService, allSpecialSchedulerState , allSpecialSchedule,getSpecialSchedulerByIdState, reset, resetGetSpecialSchedulerDetail, AddSpecialSchedulerService, UpdateSpecialSchedulerService } = priceSchedulerStore;
  const initialValues: any = specialSchedulerDetails;
  
  /**
   * The useEffect Hook lets you perform side effects in function component.
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered
   * while a dependency of the useEffect has changed.
   */

  useEffect(() => {
    GetAllSpecialSchedulerService(getTenantAccessFromLocalStorage(), getPriceSchedulerAccess.plId);
    if (props.id > 0) {
      GetSpecialSchedulerServiceById(props.id, getTenantAccessFromLocalStorage());
    }
  }, []);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "addUpdateUserSuccess" of the useEffect changed.
   */
  useEffect(() => {
    if (addUpdateSpecialSchedulerState.success) {
      if (props.id === -1) toast.success(formatMessage("added_success"));
      else toast.success(formatMessage("updated_success"));
      onModalClosed();
    }
  }, [addUpdateSpecialSchedulerState.success]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "addUpdateUserError" of the useEffect changed.
   */
  useEffect(() => {
    if (addUpdateSpecialSchedulerState.error) {
      toast.error(formatMessage(addUpdateSpecialSchedulerState.error));
      reset();
    }
  }, [addUpdateSpecialSchedulerState.error]);

  /**
   * This function adds the branch when "Id < 0" and updates the Existing branch when Id > 0 by providing form values to the
   * correponding function
   */
  const onSubmitForm = (values: any) => {
    var addObj: IAddSpecialScheduler = {
      TenantId: getTenantAccessFromLocalStorage(),
      PlId: getPriceSchedulerAccess.plId,
      ScheduleType: Number(values.ScheduleType),
      StartTime: values.startTime,
      EndTime: values.endTime,
      StartDate: values.startDate,
      EndDate: values.endDate,
      Data1: values.Data1,
      Data2: values.Data2,
      Data3: values.Data3,
      Data4: values.Data4,
      Data5: values.Data5,
      Data6: values.Data6,
    };
    var updateObj: IUpdateSpecialScheduler = {
      SsId: props.id,
      TenantId: getTenantAccessFromLocalStorage(),
      PlId: getPriceSchedulerAccess.plId,
      ScheduleType: Number(values.ScheduleType),
      StartTime: values.startTime,
      EndTime: values.endTime,
      StartDate: values.startDate,
      EndDate: values.endDate,
      Data1:values.Data1,
      Data2:values.Data2,
      Data3:values.Data3,
      Data4:values.Data4,
      Data5:values.Data5,
      Data6:values.Data6,
    };
    if (props.id < 0) AddSpecialSchedulerService(addObj);
    else UpdateSpecialSchedulerService(updateObj);
  };

  /**
   * This function closes the pop up modal and reset getbrachDetails, addUpdate branch observables (success, inprogress
   * and error).
   */
  const onModalClosed = () => {
    resetGetSpecialSchedulerDetail();
    props.modalClosed();
  };

  return (
    <React.Fragment>
      <AddUpdateSpecialSchedulerForm
        initialValues={initialValues}
        allSpecialSchedules={allSpecialSchedule}
        id={props.id}
        submitHandler={onSubmitForm}
        onModalClosed={onModalClosed}
        isLoading={
          addUpdateSpecialSchedulerState.inProgress ||
          getSpecialSchedulerByIdState.inProgress || allSpecialSchedulerState.inProgress
        }
      />
    </React.Fragment>
  );
};

export default observer(AddSpecialScheduler);
